import styled from 'styled-components';

interface ButtonProps {
  positive?: boolean;
}

export const Button = styled.button<ButtonProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: fit-content;
  background-color: ${(props) =>
    props.positive ? 'var(--color--green)' : 'var(--color--grey-dark)'};
  padding: 10px;
  color: white;
  border-radius: 5px;
`;
